import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CitationLinkComponent } from '../citation-link/citation-link.component';

export interface CitationInfo {
  number: number;
  tooltipText: string;
  isAvailable: boolean;
}

@Component({
  selector: 'app-citation-group',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, CitationLinkComponent],
  templateUrl: './citation-group.component.html',
  styleUrls: ['./citation-group.component.scss']
})
export class CitationGroupComponent {
  @Input() citations: CitationInfo[] = [];
  @Output() citationClick = new EventEmitter<number>();

  isExpanded = false;

  get firstCitation(): CitationInfo | undefined {
    return this.citations[0];
  }

  get remainingCitations(): CitationInfo[] {
    return this.citations.slice(1);
  }

  get hiddenCount(): number {
    return this.remainingCitations.length;
  }

  get ellipsisTooltip(): string {
    return `Show ${this.hiddenCount} more citation${this.hiddenCount > 1 ? 's' : ''}`;
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  onCitationClick(citationNumber: number): void {
    this.citationClick.emit(citationNumber);
  }
}
